import produce from 'immer'

import {
  RECORD_HISTORY_LOAD,
  RECORD_HISTORY_LOAD_SUCCESS,
  RECORD_HISTORY_LOAD_FAILURE
} from './actions'

const initialState = {
  loading: false,
  error: null,
  moduleName: null,
  item: null
}

const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case RECORD_HISTORY_LOAD: {
        draft.loading = true
        draft.error = null
        draft.item = null
        draft.moduleName = action.moduleName
        return
      }
      case RECORD_HISTORY_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.item = action.record
        return
      }
      case RECORD_HISTORY_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return state
    }
  })
}

export { reducer }
